<template>
  <div class="row">
    <div class="col col-sm-12">
      <h5 class="text-center" v-html="$t('Upload.uploadTitle')" />
      <div
        v-if="!inProgress && !loading"
        class="text-center py-3"
      >
        <a class="btn btn-lg btn-aisler-gradient" @click="selectFile" href="#">
          {{ $t('Upload.selectFile') }}
        </a>
      </div>

      <form name="upload" class="visually-hidden">
        <input
          ref="filePicker"
          id="file"
          type="file"
          name="file"
          @change="fileSelected"
        >
      </form>

      <p class="text-center" v-html="$t('Upload.uploadInfo')" />

      <p class="text-center">
        <small><i class="fas fa-lock" />&nbsp;{{ $t('Upload.secureUpload') }}</small>
      </p>
    </div>

    <div
      class="col-12 d-flex flex-row text-center align-items-center justify-content-center gap-2 py-3"
    >
      <div v-html="$t('Upload.tryOut')" />
      <LoadingButton
        class="btn btn-info"
        @click="uploadExample(require('assets/example-project.kicadpcb'))"
        :loading="loadingExample"
      >
        {{ $t('Upload.tryOutBtn') }}
      </LoadingButton>
    </div>

    <div
      class="col-sm-12 col-lg-10 offset-lg-1"
    >
      <div
        class="row my-3 g-3"
      >
        <div
          class="col-sm-6 col-md-4 col-lg-2 text-center d-inline-flex align-items-center"
          v-for="app in applications"
          :key="app"
        >
          <img :src="require(`images/logos/${app}.png`)" class="logo-upload p-2">
        </div>
      </div>
    </div>

    <div
      class="col-sm-12 col-lg-10 offset-lg-1"
    >
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>{{ $t('Upload.application') }}</th>
            <th colspan="3">
              {{ $t('Upload.recommendedUploadMethod') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="app in applications" :key="app">
            <td v-html="$t(`Upload.app_title_${app}`)" />
            <td v-html="$t(`Upload.app_format_${app}`)" />
            <td v-html="$t(`Upload.app_description_${app}`, '')" />
            <td>
              <a
                v-if="$te(`Upload.app_link_${app}`, 'en')"
                :href="$t(`Upload.app_link_${app}`)"
                target="_blank"
              >
                {{ $t('Upload.details') }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { pageUrl } from 'helper/clientDetails';
import messages from 'locales/Upload';
import LoadingButton from '../helper/LoadingButton.vue';

export default {
  name: 'ProjectBoardingUpload',
  components: { LoadingButton },
  props: {
    applications: Array,
  },
  data() {
    return {
      loadingExample: false,
    };
  },
  computed: {
    ...mapState(['inProgress', 'failed', 'message', 'loading']),
  },
  methods: {
    ...mapActions(['upload']),
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    fileSelected(evt) {
      window.plausible('onboarding_upload', { u: pageUrl(), props: { method: 'file-picker' } });
      this.scrollToTop();
      this.upload(Array.from(evt.target.files));
    },
    selectFile() {
      this.$refs.filePicker.click();
    },
    async uploadExample(exampleProjectPath) {
      window.plausible('example_upload', { u: pageUrl() });

      try {
        this.loadingExample = true;
        const response = await fetch(exampleProjectPath);
        const blob = await response.blob();
        const filename = 'example-project.kicad_pcb';
        const exampleFile = new File([blob], filename, { type: 'application/octet-stream' });

        this.scrollToTop();
        this.upload([exampleFile]);
      } catch {
        // Silently ignore
      } finally {
        this.loadingExample = false;
      }
    }
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>
.logo-upload {
  filter: grayscale(100%);
  max-height: 4rem;
  max-width: 100%;
}
</style>
